import React, { useState, useEffect, useContext } from "react";
import { handleApiError } from "@/utils/toastUtil";

import { MenuSelect } from "../components/Form";
import { TbUser } from "react-icons/tb";
import { AiOutlinePoweroff } from "react-icons/ai";
import { MdOutlineNotificationsNone } from "react-icons/md";
import NotificationComp from "../components/NotificationComp";
import { useNavigate } from "react-router-dom";
import { BiMenu } from "react-icons/bi";
import MenuDrawer from "../components/Drawer/MenuDrawer";
import { logout } from "../api/auth-scripts";
import UserContext from "../context/UserContext";
import { toast } from "react-toastify";
import api from "../api";
import { io } from "socket.io-client";
import { FiMenu } from "react-icons/fi";
import LanguageSelector from "../components/LanguageSelector";
import i18n from "../utils/i18n";
import { Badge, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { t } from "i18next";

const getInitials = (name, surname) => {
  const firstNameInitial = name ? name.charAt(0).toUpperCase() : "";
  const surnameInitial = surname ? surname.charAt(0).toUpperCase() : "";
  return firstNameInitial + surnameInitial;
};

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const { setUser, user } = useContext(UserContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();

  const handleCleanNotification = (notification) => {
    if (notification.id) {
      api
        .delete(`/notifications/${notification.id}`)
        .then((response) => {
          setNotifications(
            notifications.filter(
              (eachNotification) => eachNotification.id !== notification.id
            )
          );
        })
        .catch((error) => {
          handleApiError("toast.extra.errors.notification_clear_failed");
        });
    } else {
      setNotifications(
        notifications.filter(
          (eachNotification) => eachNotification.tempId !== notification.tempId
        )
      );
    }
  };
  // useEffect(() => {
  //   const socket = io(
  //     BASE_URL,
  //     {
  //       withCredentials: true,
  //       transports: ["websocket"],
  //     }
  //   );

  //   socket.on("connect", () => {});

  //   socket.on("appointmentNotification", (notification) => {
  //     if (
  //       !notifications.some((n) => n.id === notification.id) &&
  //       !notifications.some((n) => n.tempId === notification.tempId)
  //     )
  //       setNotifications((prev) => [...prev, notification]);
  //   });

  //   socket.on("disconnect", () => {});

  //   return () => {
  //     socket.disconnect();
  //   };
  // }, []);
  const handleNotificationClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setAnchorEl(null);
  };
  const role = user?.role === "reception" ? "receptionist" : user?.role;

  // Toggle drawer
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  // Dropdown menu for profile and logout
  const DropDown1 = [
    {
      title: t("dropdown.profile"),
      icon: TbUser,
      onClick: () => {
        navigate(`/${role}/settings`);
      },
    },
    {
      title: t("dropdown.logout"),
      icon: AiOutlinePoweroff,
      onClick: () => {
        logout(navigate, toast, setUser);
      },
    },
  ];

  useEffect(() => {
    document.documentElement.setAttribute("dir", i18n.dir());
    document.documentElement.setAttribute("lang", i18n.language);
  }, [i18n.language, notifications]);

  // Conditionally render the header only if user exists
  if (!user) {
    return null; // Render nothing if no user data
  }

  return (
    <div dir={i18n.dir()}>
      {isOpen && <MenuDrawer isOpen={isOpen} toggleDrawer={toggleDrawer} />}

      {/* Header component */}
      <div
        className={`w-full 2xl:max-w-none bg-dry grid md:grid-cols-2 grid-cols-12 items-center bg-opacity-95 top-0 z-40 xs:px-8 px-2 ${
          i18n.language === "ar"
            ? "flex-row-reverse text-right"
            : "flex-row text-left"
        }`}>
        <div className="md:col-span-1 sm:col-span-11 col-span-10 flex gap-4 items-center md:py-0 py-4">
          <button
            onClick={toggleDrawer}
            className={`block md:hidden text-2xl w-12 md:w-12 h-12 rounded-full flex-colo transitions text-gray-600 hover:text-subMain ${
              i18n.language === "ar" ? "ml-auto" : "mr-auto"
            }`}>
            {" "}
            <FiMenu className="text-2xl" />
          </button>

          {/* <button
            onClick={toggleDrawer}
            className="block xl:hidden border text-2xl bg-greyed w-16 md:w-12 h-12 rounded-md flex-colo text-textGray transitions hover:bg-border">
            <BiMenu />
          </button> */}
        </div>
        <div className="md:col-span-1 sm:col-span-1 col-span-2 items-center justify-end pr-4 md:pr-0">
          <div
            className={`float-right flex gap-4 items-center justify-center ${
              i18n.language === "ar" ? "flex-row-reverse" : ""
            }`}>
            <div className={`${i18n.language === "ar" ? "ml-4" : "mr-4"}`}>
              <LanguageSelector />
            </div>
            {/* MUI Notification Menu */}
            <IconButton color="inherit" onClick={handleNotificationClick}>
              <Badge
                badgeContent={notifications?.length}
                color="primary"
                overlap="circular">
                <MdOutlineNotificationsNone className="text-2xl hover:text-subMain" />
              </Badge>
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleNotificationClose}
              PaperProps={{
                style: {
                  maxHeight: 300,
                  width: "250px",
                  marginTop: 10,
                  borderRadius: "8px",
                },
              }}>
              {notifications.length > 0 ? (
                notifications.map((notification, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => handleCleanNotification(notification)}>
                    <Typography variant="body2">
                      {notification.message}
                    </Typography>
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>
                  <Typography sx={{ color: "#000", fontWeight: 500 }}>
                    {t("notifications.none")}
                  </Typography>
                </MenuItem>
              )}
            </Menu>

            <div className="items-center md:flex">
              <MenuSelect datas={DropDown1}>
                <div className="flex gap-4 items-center p-4 rounded-lg">
                  <div className="w-12 h-12 bg-subMain text-white rounded-full flex items-center justify-center font-medium text-base">
                    {user?.name && user?.surname
                      ? getInitials(user.name, user.surname)
                      : "NA"}
                  </div>
                  <p
                    className={`text-sm text-textBlack font-medium hidden md:flex ${
                      i18n.language === "ar" ? "text-right" : "text-left"
                    }`}>
                    {user?.name + " " + user?.surname}
                  </p>
                </div>
              </MenuSelect>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
